import { DataSourceCheckoutRegionsQueryProviderProps } from "./data-source-checkout-regions-query";

export type DataSource_CheckoutRegions_QueryKeyType = [
  string,
  Omit<DataSourceCheckoutRegionsQueryProviderProps, "useInitialState">
];

const baseKey = `bbnt-data-source-checkout-regions`;

export const DataSource_CheckoutRegions_QueryKey = {
  checkoutRegions: (
    desiredRegions: DataSourceCheckoutRegionsQueryProviderProps
  ): DataSource_CheckoutRegions_QueryKeyType => {
    const baseQueryKey = baseKey;

    const { useInitialState, ...desiredRegions_cleaned } = {
      ...desiredRegions,
    };

    const queryKey: DataSource_CheckoutRegions_QueryKeyType = [
      baseQueryKey,
      desiredRegions_cleaned,
    ];

    return queryKey;
  },
};
